module.exports = new __parcel__URL__("BricksByTheBay.239680cf.avif").toString();